import { ResultTypeFrom } from '@reduxjs/toolkit/query';
import { Optional } from '@direct-frontend/stdlib';
import { AnyQueryDefinition } from '../../../apiSSRModule';
import { BaseRowData, RequestedChunks } from '../../types';

/** Опции для итерации по чанкам */
type IterateOverChunksOptions<Definition extends AnyQueryDefinition, RowData extends BaseRowData> = {
    /** Функция получения строки из ответа эндпоинта */
    getRowByIndex: (chunkData: ResultTypeFrom<Definition>, rowIndexInChunk: number) => Optional<RowData>;
    /** Длина чанка */
    chunkLength: number;
};

/** Итерирует по всем строкам в чанках и вызывает коллбек для каждой строки */
export function iterateOverChunks<
    Definition extends AnyQueryDefinition,
    RowData extends BaseRowData,
    Chunks extends RequestedChunks<Definition>,
>(
    requestedChunks: Chunks,
    cachedValues: { data?: ResultTypeFrom<Definition> }[],
    callback: (rawData: RowData, requestedChunk: Chunks[number], rowIndexInChunk: number) => void,
    { chunkLength, getRowByIndex }: IterateOverChunksOptions<Definition, RowData>,
    failCallback?: (
        requestedChunk: Chunks[number],
        rowIndexInChunk: number,
        cachedValue?: { data?: ResultTypeFrom<Definition> }
    ) => void
) {
    for (let index = 0; index < requestedChunks.length; index += 1) {
        const requestedChunk = requestedChunks[index];
        const cachedValue = cachedValues[index];

        if (!requestedChunk || !cachedValue || !cachedValue.data) {
            continue;
        }

        for (let rowIndexInChunk = 0; rowIndexInChunk < chunkLength; rowIndexInChunk += 1) {
            const data = getRowByIndex(cachedValue.data, rowIndexInChunk);

            if (data) {
                callback(data, requestedChunk, rowIndexInChunk);
            } else if (failCallback) {
                failCallback(requestedChunk, rowIndexInChunk, cachedValue);
            }
        }
    }
}
